import { c as _c } from "react/compiler-runtime";
import React from "react";
interface TabOption {
  readonly key: string;
  readonly label: string;
  readonly leadingIcon?: React.ReactNode | undefined;
  readonly hasIndicator?: boolean | undefined;
  readonly panelId: string;
  readonly action?: React.ReactNode | undefined;
}
interface TabToggleProps {
  readonly options: readonly TabOption[];
  readonly activeKey: string;
  readonly onSelect: (key: string) => void;
  readonly fullWidth?: boolean | undefined; // New prop to control width
}
export const TabToggle: React.FC<TabToggleProps> = t0 => {
  const $ = _c(25);
  const {
    options,
    activeKey,
    onSelect,
    fullWidth: t1
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const hasActions = options.some(_temp);
  let t2;
  if ($[0] !== activeKey || $[1] !== fullWidth || $[2] !== onSelect) {
    t2 = (option_0, style) => <button key={option_0.key} onClick={() => onSelect(option_0.key)} role="tab" aria-selected={activeKey === option_0.key} aria-controls={option_0.panelId} style={style} className={`tw-relative tw-whitespace-nowrap tw-border-x-0 tw-border-b-2 tw-border-t-0 tw-border-solid tw-bg-transparent tw-py-3 tw-text-sm tw-font-medium tw-transition-all tw-duration-200 ${fullWidth ? "tw-flex tw-flex-1 tw-justify-center tw-text-center" : ""} ${activeKey === option_0.key ? "tw-border-primary-300 tw-text-white" : "tw-border-transparent tw-text-iron-500 desktop-hover:hover:tw-text-iron-200"}`}><span className="tw-inline-flex tw-h-5 tw-items-center tw-gap-1 tw-align-middle tw-leading-5">{option_0.leadingIcon}<span className="tw-leading-5">{option_0.label}</span></span>{option_0.hasIndicator && <div className="tw-absolute -tw-right-1 tw-top-1 tw-h-2 tw-w-2 tw-rounded-full tw-bg-red" />}</button>;
    $[0] = activeKey;
    $[1] = fullWidth;
    $[2] = onSelect;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const renderTabButton = t2;
  if (!hasActions) {
    const t3 = `tw-flex tw-gap-x-1 ${fullWidth ? "tw-w-full" : "tw-w-auto"}`;
    let t4;
    if ($[4] !== options || $[5] !== renderTabButton) {
      let t5;
      if ($[7] !== renderTabButton) {
        t5 = option_1 => renderTabButton(option_1);
        $[7] = renderTabButton;
        $[8] = t5;
      } else {
        t5 = $[8];
      }
      t4 = options.map(t5);
      $[4] = options;
      $[5] = renderTabButton;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
      t5 = <div className={t3} role="tablist">{t4}</div>;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  const t3 = `tw-flex tw-gap-x-1 ${fullWidth ? "tw-w-full" : "tw-w-auto"}`;
  let t4;
  if ($[12] !== options || $[13] !== renderTabButton) {
    let t5;
    if ($[15] !== renderTabButton) {
      t5 = (option_2, index) => renderTabButton(option_2, {
        order: index * 2
      });
      $[15] = renderTabButton;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t4 = options.map(t5);
    $[12] = options;
    $[13] = renderTabButton;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <div className="tw-contents" role="tablist">{t4}</div>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== options) {
    t6 = options.map(_temp2);
    $[19] = options;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t3 || $[22] !== t5 || $[23] !== t6) {
    t7 = <div className={t3}>{t5}{t6}</div>;
    $[21] = t3;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};
function _temp(option) {
  return option.action !== undefined && option.action !== null;
}
function _temp2(option_3, index_0) {
  if (option_3.action === undefined || option_3.action === null) {
    return null;
  }
  const actionOrder = index_0 * 2 + 1;
  return <div key={`${option_3.key}:action`} style={{
    order: actionOrder
  }} className="tw-border-x-0 tw-border-b-2 tw-border-t-0 tw-border-solid tw-border-transparent">{option_3.action}</div>;
}